import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "star-content" }
const _hoisted_2 = ["src"]

import {onMounted, ref, watch} from "vue";

interface Props{
  score:number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'StarScore',
  props: {
    score: { default: 0 }
  },
  setup(__props: any) {


const props=__props

const starList=ref([
  require('../../assets/img/star.png'),require('../../assets/img/star.png'),require('../../assets/img/star.png'),require('../../assets/img/star.png'),require('../../assets/img/star.png')
])


watch(()=>props.score,(newval)=>{
  console.log(2,newval)
  const pos=Math.floor(newval/2),
      n=newval%2;
  const list=starList.value;
  console.log(pos,n)
  for(let i=0;i<pos;i++){
    list[i]=require('../../assets/img/star2.png');
  }
  if(n==1){
    list[pos]=require('../../assets/img/star3.png');
  }
  starList.value=list;
},{immediate:true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(starList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("img", {
        src: item,
        mode: "widthFix",
        key: index
      }, null, 8, _hoisted_2))
    }), 128))
  ]))
}
}

})